import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit, EventEmitter, Output } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ReactiveFormsModule, UntypedFormGroup } from '@angular/forms';
import { AuthService } from '@entscheidungsnavi/api-client';
import { MatError } from '@angular/material/form-field';
import { MatButton } from '@angular/material/button';
import { OverlayProgressBarDirective } from '../../overlay-progress-bar';
import { PasswordFormComponent } from '../../form-elements';

@Component({
  selector: 'dt-change-password',
  templateUrl: 'change-password.component.html',
  styleUrls: ['./change-password.component.scss'],
  imports: [ReactiveFormsModule, MatError, MatButton, OverlayProgressBarDirective, PasswordFormComponent],
})
export class ChangePasswordComponent implements OnInit {
  form: UntypedFormGroup;

  @Output()
  changePasswordSuccess = new EventEmitter();

  constructor(
    private authService: AuthService,
    private snackBarService: MatSnackBar,
  ) {}

  ngOnInit() {
    this.form = new UntypedFormGroup({});
  }

  onSubmit() {
    this.form.updateValueAndValidity();

    if (this.form.valid) {
      this.form.disable({ emitEvent: false });

      const newPassword: string = this.form.controls.password.value;
      const oldPassword: string = this.form.controls.oldPassword.value;
      this.authService.changePassword(oldPassword, newPassword).subscribe({
        next: () => {
          this.snackBarService.open($localize`Passwort erfolgreich geändert!`, undefined, { duration: 4000 });
          this.changePasswordSuccess.emit();
        },
        error: (err: HttpErrorResponse) => {
          this.form.enable();

          if (err.status === 401) {
            this.form.setErrors({ 'wrong-password': true });
          } else {
            this.form.setErrors({ 'server-error': true });
          }
        },
      });
    }
  }
}
